import { TableColumn, TableConfig } from "../../../@shared/models/table.models";

export const PROJECTS_TABLE_COLUMNS: TableColumn[] = [
    {
        field: "name",
        header: "Project Name",
        type: "custom",
        template: "projectNameTemplate",
        width: "20%"
    },
    {
        field: "customer",
        header: "Customer",
        type: "custom",
        template: "customerTemplate",
        width: "15%"
    },
    {
        field: "upcomingMilestone",
        header: "Upcoming Milestone",
        type: "custom",
        template: "upcomingMilestoneTemplate",
        width: "20%"
    },
    {
        field: "manager",
        header: "Manager",
        type: "custom",
        template: "managerTemplate",
        width: "12%"
    },
    {
        field: "status",
        header: "Status",
        type: "custom",
        template: "statusTemplate",
        width: "12%"
    },
    {
        field: "dueDate",
        header: "Due Date",
        type: "custom",
        template: "dueDateTemplate",
        width: "13%"
    },
    {
        field: "createdAt",
        header: "Created",
        type: "custom",
        template: "dateCreatedTemplate",
        width: "12%"
    },
    {
        field: "actions",
        header: "Actions",
        type: "custom",
        template: "actionsTemplate",
        width: "4%"
    }
];

export const PROJECTS_TABLE_CONFIG: TableConfig = {
    selectable: false,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [20, 30, 40],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No projects found",
    globalFilter: false,
    responsive: true
}; 
